import { useContext, useEffect, useRef } from 'react';

import UiContext from 'common/UiContext/UiContext';

// Fires a one-off toast when the number of workers below their hashrate alert
// limit rises during a session (i.e. a rig just dropped). Stays silent on the
// initial load and when the count holds steady or falls — the banner covers the
// standing state; this is the "it just happened" ping.
const useLowHashrateAlert = (count?: number) => {
  const { addToast } = useContext(UiContext);
  const previous = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (count === undefined) {
      return;
    }

    if (previous.current !== undefined && count > previous.current) {
      const delta = count - previous.current;

      addToast?.(
        `${delta} worker${delta > 1 ? 's' : ''} dropped below the hashrate alert limit`,
        'Exclamation',
      );
    }

    previous.current = count;
  }, [count, addToast]);
};

export default useLowHashrateAlert;
